import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import { $, $$, showToast } from '@js/utils';
import { stat, getCardList } from '../../js/utils';
import Feedback from '../../js/feedback.js';
import './index.scss';

let env = window.pageData.COMMON.ENV === 'development';

import './index.scss';
const EventHandler = {
  more() {
    if (window.wv.isMethodValid('BrowserIFlow.jumpMediaHome')) {
      let reportData = {
        openSource: 'relatedCard',
      };
      stat(20083637, 21034, 10012, reportData);
      window.wv.invoke('BrowserIFlow.jumpMediaHome');
    }
  },
  openDetail(node, event) {
    const { sourceVal } = window.store;
    let index = +node.dataset.index;
    let cardListData = this.reportDataList[index];
    let reportData = {
      avatar: cardListData.avatar,
      clickPage: 'relatedCard',
      mediaNo: cardListData.mediaNo,
      mediaId: cardListData.mediaId,
      name: cardListData.name,
      source: sourceVal,
      summary: cardListData.summary,
    };
    wv.openDetail && wv.openDetail(reportData);
  },
  attention(node, event) {
    let index = +node.dataset.index;
    let cardListData = this.reportDataList[index];
    console.log('关注', [
      cardListData.mediaNo,
      cardListData.name,
      cardListData.isAttention,
    ]);
    window.store.cardContent = {
      node: node,
      event: event,
      isCard: true, //是否是卡片关注
      cardisSubscribe: cardListData.isAttention,
    };
    wv.subscribe(
      cardListData.mediaNo,
      cardListData.name,
      'oppo',
      cardListData.isAttention,
    );
  },
  close(node, event) {
    event.stopPropagation();
    let index = +node.dataset.index;
    let spliceIndex = 0;
    // 用index去匹配数据的index进行删除
    this.cardList.forEach((v, i) => {
      if (v.index === index) {
        spliceIndex = i;
      }
    });
    let cardListData = this.cardList[spliceIndex];
    // 埋点
    let reportData = {
      iflowSource: 'oppo',
      mediaName: cardListData.name,
      mediaId: cardListData.mediaId,
      mediaAuthority: cardListData.mediaAuthority,
    };
    stat(20083630, 21034, 10012, reportData);
    $(`.card__${index}`).classList.add('scale_transition');
    setTimeout(() => {
      $(`.card__${index}`).classList.add('setWidth');
    }, 200);
    this.cardList.splice(spliceIndex, 1);
    if (this.cardList.length === 0) {
      // 更新箭头状态
      EventEmit.instance.emit('isUp', true);
      this.card.dataset.show = 0;
      this.cardListIsShown = false;
      // $('.document-media__show').classList.add('document-media__show_up');
    }
  },
};

export default class Share {
  constructor(el, name, data = {}) {
    this.el = el;
    this.cardList = [];
    this.oldCardList = [];
    this._eventHandler = {};
    this.cardListIsShown = false;
    this.card = $('.card');
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
    if (env) {
      // this.mockData()
    }
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
    EventEmit.instance.on(
      'cardStatusChangeCallback',
      this.cardStatusChangeCallback.bind(this),
    );
    EventEmit.instance.on('cardListEvent', this.cardListHandler.bind(this));
  }
  // 解决手势问题,滑动卡片的时候把手势功能关闭,触碰其他地方重新打开
  touchCard() {
    if (!window.wv.isMethodValid('BrowserIFlow.setForbidSlide')) {
      return;
    }
    let taskCenterdialog = document.querySelector('.card__box ');
    taskCenterdialog.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      window.wv.invoke('BrowserIFlow.setForbidSlide', true);
    });
  }
  // 卡片关注状态切换,点击之后把里面的isAttention取反,这样每次传值就不会一样
  checkoutCardAttention(index, value) {
    this.reportDataList[index].isAttention = value;
  }
  cardStatusChangeCallback(mediaNo, isSubscribe) {
    console.log('cardStatusChangeCallback', mediaNo);
    // 卡片关注同步 这里不对！！！
    let cardAttention = document.getElementById(`${mediaNo}`);
    console.log(cardAttention);
    if (cardAttention) {
      let index = +cardAttention.getAttribute('data-index');
      if (!isSubscribe) {
        console.log('媒体页取消卡片关注成功', mediaNo, isSubscribe, index);
        cardAttention.innerHTML = '关注';
        cardAttention.classList.remove('followed');
        this.checkoutCardAttention(index, true);
      } else {
        console.log('媒体页卡片关注成功', mediaNo, isSubscribe, index);
        cardAttention.innerHTML = '已关注';
        cardAttention.classList.add('followed');
        this.checkoutCardAttention(index, true);
      }
    }
  }

  // 曝光埋点方法
  //domid 曝光的节点 value匹配的数据数据
  exposeStat() {
    let reportData = {
      mediaId: '',
      mediaName: '',
      sourceMediaId: window.store.media.outId,
      sourceMediaName: window.store.media.name,
    };
    let data;
    var observer = new IntersectionObserver((entries) => {
      entries.forEach((item) => {
        if (item && item.isIntersecting) {
          if (item.target.dataset.index) {
            data = this.reportDataList[+item.target.dataset.index];
            (reportData.mediaId = data.mediaId || ''),
              (reportData.mediaName = data.name || ''),
              stat(20083999, 21034, 10012, reportData);
          }
        }
      });
    });

    let newArr = Array.from(document.querySelectorAll('.card__content'));
    newArr.forEach((item) => observer.observe(item));
  }
  mockData() {
    const cardList = require('./mock').cardList;
    this.cardList = cardList.concat(cardList);
    this.reportDataList = Object.assign({}, cardList);
  }

  async cardListHandler(shown, reportData) {
    if (shown) {
      if (this.cardList.length === 0) {
        if (env) {
          let temp = Math.random();
          console.log('random', temp);
          if (temp > 0.5) {
            this.mockData();
          } else {
            this.cardList = [];
          }
        } else {
          this.cardList = await getCardList();
        }
        if (this.cardList.length === 0) {
          showToast('未获取到卡片列表信息');
          return;
        }
      }
      if (!this.card) this.card = $('.card');
      this.reportDataList = Object.assign({}, this.cardList);
      // debugger;
      this.render();
      this.card.dataset.show = 1;
      this.cardListIsShown = true;
      console.log(reportData, '展开埋点');
      stat(20084039, 21034, 10012, reportData);
    } else {
      if (this.cardListIsShown) {
        this.card.dataset.show = 0;
        this.cardListIsShown = false;
        console.log(reportData, '隐藏埋点');
        stat(20084040, 21034, 10012, reportData);
      }
    }
  }
  render() {
    this.el.innerHTML = template({
      cardList: this.cardList,
    });
    this.exposeStat();
    this.touchCard();

    const FeedbackBtns = $$('.btn-feedback', this.el);
    // FeedbackBtns.push(this.el);
    this.btnsFeedback = FeedbackBtns.map((el) => new Feedback(el));
  }
}
